export const EDIT_INFO_TEXT = {
	panelHeader: "Edit driver's details",
	closeButtonLabel: 'Close',
	generalDataHeading: 'General Data',
	employmentDataHeading: 'Employment Data',
	firstNameLabel: 'First Name',
	lastNameLabel: 'Last Name',
	homeLocationLabel: 'Home Location',
	homeLocationPlaceholder: 'e.g. Boston',
	effectiveDateLabel: 'Effective Date',
	dateShortPlaceholder: 'dd.mm.yyyy',
	phoneLabel: 'Phone number',
	phoneTooLongError: 'Too long',
	employmentTypeLabel: 'Employment type',
	employmentTypePlaceholder: 'Please select',
	employmentTypeMocked: 'Employment Type Mocked',
	startTimeLabel: 'Employment start date',
	startTimePlaceholder: 'dd.mm.yyy',
	fieldError: 'error',
	driverLicenseLabel: 'Driver licence expire date',
	medicalCheckLabel: 'Medical certificate expire date',
	saveButton: 'Save',
	unsavedPopupTitle: 'Unsaved Changes',
	unsavedPopupBody:
		'You have unsaved data. Closing the form will result in losing any changes. Are you sure you want to continue without saving?',
	unsavedGoBackButton: 'Go back',
	unsavedCloseButton: 'Close without saving',
};
